import styled from 'styled-components';
import { ModalBackground } from '../../assets/styles/Modal';
import { IModal } from 'customTypes';
import { useTranslation } from 'react-i18next';
import { useSetAuth } from '../../utils/useSetAuth';
import { BtnBlue, BtnRed } from '../Button';
import ApprovalLineTable from '../ApprovalLineTable';
import { useEffect, useState } from 'react';
import Portal from '../Portal';
import GroupChkModal from './GroupChkModal';
import { apiGet } from '../../services/_common';
import { useQuery } from '@tanstack/react-query';
import { useRecoilValue } from 'recoil';
import { userState } from '../../atoms';
import { v4 } from 'uuid';
import { InputTable } from '../../assets/styles/InputTable';

const Root = styled.div`
  position: relative;
  transition: all ease 0.8s;
  width: 100%;
  height: 100vh;
  height: inherit;
  justify-content: center;
  align-items: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .centered-content {
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  > .modal {
    z-index: 6000;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 8rem);
    width: 48rem;
    background-color: var(--board);
    border-radius: 0.5rem;
    overflow: hidden;

    > .inputForm-head {
      position: relative;
      font-weight: 500;
      flex-shrink: 0;
      padding: 0.5rem 0.5rem;
      border-bottom: 1px solid var(--outline);

      .modalHeaderTitle {
        color: var(--text-primary);
      }

      .modalHeaderCenter {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: var(--text-primary);
      }
      > svg {
        width: 24px;
        height: 24px;
      }
      .closeBtn {
        width: 2rem;
        height: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5rem;
        cursor: pointer;
        margin: 0 0.5rem;
        color: var(--text-primary);
      }
      .closeBtn:hover {
        background-color: var(--tonal);
      }
      .material-symbols-rounded {
        color: var(--text-primary);
        font-variation-settings: 'FILL' 1, 'wght' 500, 'GRAD' 0, 'opsz' 20;
      }
      .arrow-icon span {
        height: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .icon-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
        gap: 0.25rem;
        cursor: pointer;
        border-radius: 5rem;
        padding-right: 1rem;
        padding-left: 0.5rem;
        font-size: 0.875rem;
        background-color: var(--tonal);
        color: var(--text-primary);
      }
      .icon-btn:hover {
        background-color: var(--tonal-deep);
      }
    }

    > .inputForm-body {
      flex-shrink: 1;
      background-color: var(--board);
      color: #121212;
      overflow-y: initial;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      height: 100%;
      overflow-y: auto;
      padding: 1rem;

      .modal-contents-container {
        background-color: var(--board);
        flex-grow: 1;
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        .subHead {
          padding: 2rem 0;
        }
      }
      .modal-contents {
        background-color: var(--board);
        padding: 1rem;
        flex-grow: 1;
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        .subHead {
          padding: 2rem 0;
        }
      }
    }

    .modal-footer {
      display: flex;
      justify-content: flex-end;
      border-top: 1px solid var(--outline);
      padding: 0.5rem;
      > div {
        gap: 0.25rem;
        > button {
          height: 2.5rem;
          font-size: 0.875rem;
          width: 6rem;
          padding: 0;
          @media screen and (max-width: 767px) {
            width: fit-content;
            padding: 0 1.5rem;
          }
        }
      }
      > .arrows {
        button {
          gap: 0.25rem;
          width: fit-content;
          gap: 0.5rem;
          background-color: #e5f1ff;
          background-color: var(--tonal);
          &:hover {
            background-color: var(--tonal-deep);
          }
          &:nth-child(1) {
            padding-left: 0.25rem;
            padding-right: 0.5rem;
            @media screen and (max-width: 767px) {
              padding-right: 1rem;
            }
            > div:nth-child(3) {
              padding-left: 0.5rem;
              border-left: 1px solid var(--outline);
              @media screen and (max-width: 767px) {
                display: none;
              }
              p {
                text-align: left;
              }
            }
          }
          &:nth-child(2) {
            padding-left: 0.5rem;
            padding-right: 0.25rem;
            @media screen and (max-width: 767px) {
              padding-left: 1rem;
            }
            > div:nth-child(1) {
              padding-right: 0.5rem;
              border-right: 1px solid var(--outline);
              @media screen and (max-width: 767px) {
                display: none;
              }
              p {
                text-align: right;
              }
            }
          }
          > p,
          > span {
            color: var(--selected-primary);
          }
          > div {
            p {
              color: var(--text-tertiary);
              font-size: 0.625rem;
              line-height: 1.125;
              letter-spacing: 0.025rem;
              font-weight: 600;
            }
          }
        }
      }
    }
  }

  .table {
    .tbody {
      min-width: 100%;
    }
  }

  .tr {
    max-width: 100%;

    .tag {
      padding: 0.125rem 0.75rem;
      border-radius: 5px;
      color: #fff;

      &.report {
        background: var(--filled-yellow);
      }

      &.approval {
        background: var(--filled-green);
      }
    }
  }

  .w5 {
    width: 5%;
    max-width: 5%;
  }

  .w10 {
    width: 10%;
    max-width: 10%;
  }

  .w15 {
    width: 15%;
    max-width: 15%;
  }

  .w20 {
    width: 20%;
    max-width: 20%;
  }

  .w25 {
    width: 25%;
    max-width: 25%;
  }

  .w40 {
    width: 40%;
    max-width: 40%;
  }

  .w60 {
    width: 60%;
    max-width: 60%;
  }
`;

interface IUser {
  key: string;
  name: string;
}

interface IUserPart {
  grCd: string;
  grName: string;
  subList: IUser[];
}

interface Props {
  openModal: any;
  setOpenModal: any;
  lGubun: string;
  getLineList?: (list1: any[], list2: any[]) => void;
}

const ApprovalModal = ({ openModal, setOpenModal, lGubun, getLineList }: Props) => {
  const { t } = useTranslation();
  const userInfo = useRecoilValue(userState);
  const INIT_ROW_STATE = {
    lCd: '',
    lName: '',
    line1Id: [''],
    line2Id: [''],
    useYn: 'N',
    bigo: '',
    writer: '',
    wDate: '',
    editor: '',
    eDate: '',
  };
  const [tableData, setTableData] = useState<any>([]);
  const [rowState, setRowState] = useState(INIT_ROW_STATE);
  const [list1, setList1] = useState<any[]>([]);
  const [list2, setList2] = useState<any[]>([]);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [selectedKey, setSelectedKey] = useState<{ [key: string]: string | null }>({ selKey: null, selKey2: null });
  const [userPartList, setUserPartList] = useState<IUserPart[]>([]);

  const { data: capprovalLineList, isError } = useQuery(['/capprovalline/m', userInfo.hCd], () => getCapprovalAPI(), { enabled: !!userInfo.hCd && !!userInfo.sCd });
  const { data: userPartApi } = useQuery(['/user/company/part'], () => apiGet({ path: '/user/company/part', req: { hCd: userInfo?.hCd } }));

  useEffect(() => {
    capprovalLineList && setTableData(capprovalLineList.data.data.filter((el: any) => el.lGubun === lGubun));
  }, [capprovalLineList]);

  useEffect(() => {
    userPartApi &&
      setUserPartList(
        userPartApi?.data?.data?.map((el: any) => ({
          grCd: v4(),
          grName: el.partName,
          subList: el.users.map((el2: any) => ({ key: el2.userId, name: el2.userName })),
        }))
      );
  }, [userPartApi]);

  // 보고서 결재라인 리스트 조회 API
  const getCapprovalAPI = async () => {
    const req = { cCd: userInfo.hCd };
    const res = await apiGet({ path: '/capprovalline/m', req });

    if (res.status === 200) {
      return res;
    }

    return res;
  };

  // 모달창 닫기
  const onClickClose = () => {
    setOpenModal((prev: IModal) => ({ ...prev, status: false }));
  };

  // 라인 행 선택
  const onClickRow = (e: IApprovalLine, i: number) => {
    setSelectedKey({ selKey: null, selKey2: null });

    setRowState(e);

    setList1(tableData?.filter((_: IApprovalLine, idx: number) => idx === i)[0].line1Id);
    setList2(tableData?.filter((_: IApprovalLine, idx: number) => idx === i)[0].line2Id);

    setSelectedIndex(i);
  };

  const lGubunTagRender = (cd: string) => {
    switch (cd) {
      case '1':
        return <span className='tag report'>{t('보고')}</span>;
      case '2':
        return <span className='tag approval'>{t('결재')}</span>;
      default:
        return <span className='tag report'>{t('보고')}</span>;
    }
  };

  // 적용 버튼 클릭
  const onClickSave = () => {
    getLineList && getLineList(list1, list2);
  };

  return (
    <ModalBackground>
      <Root>
        <div
          className='modal'
          role='presentation'
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <div className='inputForm-head flex-between'>
            <div className='innerTabChip flex-start'>
              <div className='modalHeaderTitle'>{t(`${lGubun === '1' ? '보고' : '결재'} 라인 선택`)}</div>
            </div>
            <div className='closeBtn' onClick={onClickClose} role='presentation'>
              <span className='material-symbols-rounded'>close</span>
            </div>
          </div>

          <div className='inputForm-body inputForm'>
            <InputTable className='noFlex noScroll'>
              <div className='thead'>
                <div className='tr'>
                  <div className='w5 flex-center tableStickyNo'>No</div>
                  <div className='w10 flex-center'>{t('코드')}</div>
                  <div className='w10 flex-center'>{t('라인 구분')}</div>
                  <div className='flex-center content-overflow'>{t('라인명')}</div>
                </div>
              </div>
              <div className='table'>
                <div className='tbody'>
                  {tableData.length > 0 ? (
                    tableData.map((el: IApprovalLine, i: number) => (
                      <div
                        className={`tr ${selectedIndex === i ? 'selected' : ''}`} //
                        role='button'
                        tabIndex={0}
                        key={el.lCd}
                        onClick={() => onClickRow(el, i)}
                      >
                        <div className='w5 flex-center tableStickyNo'>{i + 1}</div>
                        <div className='w10 flex-center'>{el.lCd}</div>
                        <div className='w10 flex-center'>{lGubunTagRender(el.lGubun)}</div>
                        <div className='flex-start content-overflow'>{el.lName}</div>
                      </div>
                    ))
                  ) : (
                    <div className='noData'>No data.</div>
                  )}
                </div>
              </div>
            </InputTable>
            <ApprovalLineTable gubun={lGubun} list1={list1} list2={list2} setList1={setList1} setList2={setList2} selectedKey={selectedKey} setSelectedKey={setSelectedKey} />
          </div>
          <div className='modal-footer'>
            <div className='flex-basic'>
              <BtnBlue onClick={onClickSave}>{t('적용')}</BtnBlue>
            </div>
          </div>
        </div>
      </Root>
    </ModalBackground>
  );
};

export default ApprovalModal;
